import { render, staticRenderFns } from "./sessionsPages.vue?vue&type=template&id=37ba2bde&scoped=true"
import script from "./sessionsPages.vue?vue&type=script&lang=js"
export * from "./sessionsPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ba2bde",
  null
  
)

export default component.exports